const OTP_DESCRIPTION = "Wpisz kod z aplikacji uwierzytelniającej"
const RECOVERY_DESCRIPTION = "Użyj jednego z zapisanych kodów odzyskiwania. Każdy kod może zostać użyty tylko raz."

export class TwoFactorCredentialMode {
  constructor({ otpPanel, recoveryPanel, otpInput, recoveryInput, description, recoverySwitch, otpSwitch }) {
    this.otpPanel = otpPanel
    this.recoveryPanel = recoveryPanel
    this.otpInput = otpInput
    this.recoveryInput = recoveryInput
    this.description = description
    this.recoverySwitch = recoverySwitch
    this.otpSwitch = otpSwitch
  }

  show(mode, { focus = true } = {}) {
    const recovery = mode === "recovery"
    const activePanel = recovery ? this.recoveryPanel : this.otpPanel
    const inactivePanel = recovery ? this.otpPanel : this.recoveryPanel
    const activeInput = recovery ? this.recoveryInput : this.otpInput
    const inactiveInput = recovery ? this.otpInput : this.recoveryInput

    activePanel.hidden = false
    inactivePanel.hidden = true
    activeInput.disabled = false
    inactiveInput.disabled = true
    inactiveInput.value = ""
    this.description.textContent = recovery ? RECOVERY_DESCRIPTION : OTP_DESCRIPTION
    this.recoverySwitch.classList.toggle("hidden", recovery)
    this.otpSwitch.classList.toggle("hidden", !recovery)

    if (focus) activeInput.focus()
  }
}
